"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChunkedPosition = void 0;
const support_1 = require("../support/");
class ChunkedPosition {
    constructor(chunk, position, chunkSize) {
        this.chunk = chunk;
        this.position = position;
        this.chunkSize = chunkSize;
    }
    static copy(pos) {
        return new ChunkedPosition(support_1.Vector2.copy(pos.chunk), support_1.Vector2.copy(pos.position), support_1.Vector2.copy(pos.chunkSize));
    }
    getChunk() {
        return this.chunk;
    }
    getPosition() {
        return this.position;
    }
    getChunkSize() {
        return this.chunkSize;
    }
    add(vec) {
        const resultPos = this.position.add(vec);
        let resultPosX = resultPos.x;
        let resultPosY = resultPos.y;
        let resultChunkX = this.chunk.x;
        let resultChunkY = this.chunk.y;
        if (resultPosX < 0 || resultPosX >= this.chunkSize.x) {
            resultChunkX += Math.floor(resultPosX / this.chunkSize.x);
            resultPosX = this.realMod(resultPosX, this.chunkSize.x);
        }
        if (resultPosY < 0 || resultPosY >= this.chunkSize.y) {
            resultChunkY += Math.floor(resultPosY / this.chunkSize.y);
            resultPosY = this.realMod(resultPosY, this.chunkSize.y);
        }
        return new ChunkedPosition(new support_1.Vector2(resultChunkX, resultChunkY), new support_1.Vector2(resultPosX, resultPosY), this.chunkSize);
    }
    realMod(n, m) {
        return ((n % m) + m) % m;
    }
}
exports.ChunkedPosition = ChunkedPosition;
//# sourceMappingURL=ChunkedPosition.js.map